// @flow-strict

export const stripeData = (data: {}, context: {}): {} => {
  const connectedAccountData = _.find(data, (p: {}): {} => {
    return _.size(p.connect_account) > 0;
  });
  const connectedAccount = _.get(
    connectedAccountData,
    'connect_account',
    'Not connected');
  const connectedCurrency = _.get(context, 'profileCurrent.currency', 'Not connected');

  return {
    connectedAccount,
    connectedCurrency
  };
};
